import { render, staticRenderFns } from "./SelectOrderChannel.vue?vue&type=template&id=19dcdb6a&"
import script from "./SelectOrderChannel.vue?vue&type=script&lang=js&"
export * from "./SelectOrderChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports